import React, {useEffect, useState} from 'react';
import dayjs from 'dayjs';
import jalaliday from 'jalaliday';
import event from 'src/assets/images/icons/event.svg';
import publicService from '../../../../services/public.service';

dayjs.extend(jalaliday);

const Today: React.FC<{}> = () => {
  const [dateState, setDateState] = useState<any>(null);
  const [formattedDateState, setFormattedDateState] = useState('');

  useEffect(() => {
    // Assuming you are in Iran, which is in the 'Asia/Tehran' timezone (UTC+3:30 with DST)
    const timeZone = 'Asia/Tehran';
    const date = new Date();

    // Adjust for Daylight Saving Time (DST)
    const isDST = (dateParam: any) => {
      const year = dateParam.getFullYear();
      const januaryOffset = new Date(year, 0, 1).getTimezoneOffset();
      const julyOffset = new Date(year, 6, 1).getTimezoneOffset();
      return Math.min(januaryOffset, julyOffset) !== dateParam.getTimezoneOffset();
    };

    // Adjust the time if DST is in effect
    if (isDST(date)) {
      date.setHours(date.getHours() + 1);
    }

    const formattedDate: any = date.toLocaleDateString('fa-IR', {
      year: 'numeric',
      weekday: 'long',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      timeZone, // Set the timezone
    }).replace(/،/, ' ');

    setFormattedDateState(formattedDate);
  }, []);

  const getTime = async () => {
    try {
      const {data} = await publicService.getTime();
      setDateState(new Date(data.dateTime));
    } catch (e) {
      setDateState(null);
    }
  };

  useEffect(() => {
    let id: any = null;
    id = setInterval(() => {
      if (dateState) {
        setDateState((prev: any) => {
          return new Date(prev.setTime(prev.getTime() + 30000));
        });
      }

    }, 60000);

    return () => clearInterval(id);
  }, []);

  useEffect(() => {
    getTime();
  }, []);

  return (
    <div className="relative z-20 inline-block text-left shadow-xl rounded-full px-5 py-1">
      <div
        className="inline-flex justify-center items-center w-full py-2 text-sm font-medium focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75">
        <img src={event} alt="time" className="w-5 h-5"/>
        <span className="mx-3 whitespace-nowrap truncate" style={{direction: 'ltr'}}>
          {formattedDateState}
          {/*
          {date !== null
            ? date
              .toLocaleDateString('fa-IR', {
                year: 'numeric',
                weekday: 'long',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
              })
              .replace(/،/, ' ')
            : dayjs(new Date().getTime()).calendar('jalali').locale('fa').format('dddd-DD MMMM')}
            */}
        </span>
      </div>
    </div>
  );
};

export default Today;
